<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t('dialog.external_systems.title')"
    agree-text="dialog.save"
    disagree-text="dialog.close"
    dialog-width="80%"
    min-body-height="70vh"
    max-height="80vh"
    no-paddings-y
    header-shadow
    no-paddings-x
    :has-agree="false"
  >
    <template #body>
      <v-col v-if="isFetching">
        <main-loader></main-loader>
      </v-col>
      <v-col cols="12" v-else>
        <v-row no-gutters justify="end">
          <v-col cols="auto">
            <data-input
              :data-type="{ name: 'text' }"
              v-model="search"
              hide-details
              class="pa-4"
              clearable
              prepend-inner-icon="mdi-magnify"
              :placeholder="$i18n.t('default.find')"
            ></data-input>
          </v-col>
          <v-col cols="12" style="border-top: 1px solid rgb(204, 204, 204);">
            <v-data-table
              :search="search"
              hide-default-footer
              :loading="isFetching"
              dense
              :items="tableData"
              :headers="tableHeaders"
            ></v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import MainLoader from '@/components/MainLoader';
import DataInput from '@/components/DataInput';
import MainLargeDialog from '@/components/MainLargeDialog';
import { call } from 'vuex-pathify';
export default {
  name: 'ExternalSystemsDialog',
  components: { DataInput, MainLoader, MainLargeDialog },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    datasource: {
      type: String,
      default: '',
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
    systemId: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    isFetching: false,
    search: '',
    tableData: [],
    tableHeaders: [],
  }),
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  methods: {
    getTableData: call('externalSystems/getTableData'),
    getTableHeaders: call('externalSystems/getTableHeaders'),
    async init() {
      this.isFetching = true;
      await this.$nextTick();
      const dataArray = await Promise.resolve(
        this.getTableData({ feature_id: this.featureId, datasource: this.datasource })
      );
      console.log(dataArray);
      this.tableData = dataArray.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      const headers = await Promise.resolve(this.getTableHeaders(this.systemId));
      this.tableHeaders = [
        {
          text: '#',
          value: 'index',
          sortable: false,
          align: 'center',
        },
        ...(headers.length === 0
          ? []
          : headers.map(value => {
              return {
                text: value,
                value: value,
              };
            })),
      ];
      this.isFetching = false;
    },
  },
  watch: {
    computedIsVisible: {
      immediate: true,
      handler(nV) {
        if (nV) {
          this.init();
        }
      },
    },
  },
};
</script>

<style scoped></style>
